import { connect } from 'react-redux'
import { state_update } from '../actions'
import AiOptionSet from './AiOptionSet'
import {DEFAULT_STATE_VALUE} from '../constants';
import calcPrice from '../reducers/calcPrice'


const mapStateToProps = (state, ownProps) => {
  var clistqty= 0
  var clist= ''
  if (state['clist']!=='-1'){
    clistqty+=state['clist'].split('_').length
    clist=state['clist']
  }
//    console.log('clistqty1',clistqty)
console.log('state',state)
   // let cur_image_url =imageLogic(state);
  if (state['acharm'] !=='-1' && state['acat'] !=='-1' )
     if (state['acat'] !=='2' || (state['acat'] ==='2' && state['e1']!=='' && state.s === '9000')||(state['acat'] ==='2' && state.s !== '9000') )
     {
         clistqty+=1
         if (clist !=='') clist+='_'
         clist+=state['acat']+'|'+state['acharm']+'|'+state['am']
        if (state['acat']==='1' && state.s === '9000')
                 clist += '|'+state['ai']
        if (state['acat']==='2' && state.s === '9000')
                 clist += '|'+state['e1'] 
        if (state['acat']==='11' && state.acharm === '6997')
                 clist += '|'+state['e1'] 
        if (state['acat']==='11' && state.acharm === '6396')
                 clist += '|'+state['f'] +'|'+state['e1'] 
        if (state['acat']==='11' && (state.acharm === '6395'||state.acharm === '6394'))
                 clist += '|'+state['f'] + '|'+state['e1'] +'|'+state['e2'] 
                 
     }   
    let metal2name={
      "no":"no",
      "s":"silver",
      "g10y":"gold",
      "g14y":"gold",
      "spy":"gold",
      "spr":"rose",
      "g10r":"rose",
      "g14r":"rose",
      
    }
    let metal2name2={
      "no":"no",
      "s":"Sterling Silver",
      "g10y":"10K Yellow Gold",
      "g10r":"10K Rose Gold",
      "g10w":"10K White Gold",
      "-1":"",
      
    } 
  var maxclist =0  
  if (state.sku ==='9000')
    maxclist =state['clist'].split('_').length
  else {
    //console.log('clistmax',state.clist)
    var allsku = state['clist'].split('_')
    var skunext=0
    for (var i in allsku){
      skunext =parseInt(allsku[i].split('|')[1],10)
    //  console.log('clistmax',skunext)
      if (skunext >= 9277 && skunext <= 9289)
       maxclist +=1
      else
       maxclist +=2
     // console.log('clistmax',skunext,maxclist)
      
    }
  }  


 // console.log('log',state)
  return {
    options: getOptions(state),
    optionE: state['options_e'],
    s: state['s'],
    addbutton:state['clist']==='-1' && state['acharm']==='-1' ?'Start Customizing':'+ Another Charm',
    addbuttontext:state['chain']==='9000' ? 'Selected: '+metal2name2[state.m] +' Cable Link Chain adjustable up to 18 inches':'Selected: '+metal2name2[state.m] +' Paper Clip Chain 18 inches',
    //addbuttontext:'',
    addbuttontextLocket: 'Selected: '+metal2name2[state.m] +' Locket and Chain.',
    acat: state['acat'],
    acharm: state['acharm'],
    locket: state['locket'],
    chain: state['chain'],
    esa:state['esa'],
    esadetail:state['esadetail'],
    pricedetails: state['pricedetails'],
    //price: state['price'],
    price: calcPrice(state),
    activetype:[state['acat'],state['acharm'],state['e1'],state['ai'],state['am']],
    optionSize: ownProps.optionSize === 'big' ? 120: 100,
    sizeName: ownProps.optionSize,
    single_sc_option: (state.hasOwnProperty('option_all') && state['options_all'].indexOf('sc') !== -1 && state['sc'] === DEFAULT_STATE_VALUE) ? true : false,
    options_all: state['options_all'].join('-'),
    cs_details: state.cs_details[state.sku] !== undefined?state.cs_details[state.sku]:"",
    cs_details1: state.cs_details,
    np:(state['acat'] !== '2') || (state['acat'] === '2' && state.s !== '9000') || (state['acat'] === '2' && state['e1'] !=='' && state['e1'] !==undefined && state.s === '9000')?true:false,
    maxclist:state.sku==="9000"? maxclist<6:maxclist <12,
    maxclist2:state['clist'].split('_').length ,
    aireview:!['9000','9082'].includes(state.sku),
    charms:['9000','9082'].includes(state.sku),
    showtext9000: state.sku==='9000'  && state.chain === '-1',
    realinit: state.realinit,
    chainsku: state.chain,
    showtext9082: state.style==='9082' && state.locket === '-1',
    //style:state.s,
    chainmetal:metal2name[state.m],
    chainm:state.m,
    clistqty: clistqty,  
    properties:[{property:'1',value:'v1',value2:'x'},{property:'1',value:'v1',value2:'x'}],
    //clist: decodeURIComponent(clist),
    clist: clist,
    charmreview:state.charmreview,
    title:state.title,
    lsbefore:state.lsbefore,
    altered:state.altered,
    active_view: state['active_view']
  }
}

function getOptions (state) 
{
  var res={};
  var all_options=state['options_all'];
  res['options_all'] = all_options;
  for (var i in all_options)
    {
      res['options_' + all_options[i]]= state['options_' + all_options[i]]
      res['value_' + all_options[i]]= state[all_options[i]]
    }

  //console.log('getOptions',res,state);  
  return res;  
}

 

const mapDispatchToProps = (dispatch, ownProps) => ({
  onAdd: ( (stat) => {
    dispatch(state_update({attr:'add',value:'stat'}) )
    dispatch(state_update({attr:'acust',value:'charm'}));
}
  ),
  onInit: ( (stat) => {
    dispatch(state_update({attr:'realinit',value:'init'}) )
}
  ),
  onHideCharm: ( () => dispatch(state_update({attr:'charmreview',value:false}))),
  onDel: ( (val) => {
    //console.log('close OpenBox')
    if (val==='chain')
    {
    dispatch(state_update({attr:'m',value:'no'}))
    }
    else if (val==='locket')
    {
    dispatch(state_update({attr:'locket',value:'no'}))
    }
    else
    dispatch(state_update({attr:'delcharm',value:val}))
    
  }),
  onESA: ( (val) => {
    console.log('esaval',val)
    if (val===true)
    {
    dispatch(state_update({attr:'esaselected',value:true}))
    }
    else
    dispatch(state_update({attr:'esaselected',value:false}))
    
  }),
  onClick:( () => { 
    dispatch(state_update({attr:'active_view',value:ownProps.active_view}  ))
  })
 // onClick: () =>state_update({attr:ownProps.attr,value:ownProps.value})
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AiOptionSet)


// WEBPACK FOOTER //
// ./src/layout/AiOptionSetWrap.js